<section class="sec-overlay sec-overlay-theme bg-img"
    style="background-image: url('../../../assets/images/new-images/Inner-Banner.png');">
    <div class="container pt--0 pb--0">
        <div class="row justify-content-center divider-style1 pb-1 pt-5">
            <div class="col-lg-10 col-xl-7">
                <div class="divider-content text-center">
                    <h4 class="sub-title aos-init aos-animate" data-aos="fade-down">We have great</h4>
                    <h2 class="title aos-init aos-animate" data-aos="fade-down">achivements to show
                    </h2>
                    <ul class="d-flex justify-content-evenly border-0 bg-transparent text-center ps-0">
                        <li class="list-group-item border-0 bg-transparent">
                            <!-- <span class="border-box"></span> -->
                            <h3 class="text-white">{{getCount('STUDENTS')}}+</h3>
                            <img src="assets/img/icons/student.png" width="30px" width="30px" class="img-fluid" alt="">
                            <h6 class=" mt-3 text-white">Students</h6>

                        </li>
                        <li class="list-group-item border-0 bg-transparent">
                            <!-- <span class="border-box"></span> -->
                            <h3 class="text-white">{{getCount('COURSES')}}+</h3>
                            <img src="assets/img/icons/courses.png" width="30px" width="30px" class="img-fluid" alt="">
                            <h6 class=" mt-3 text-white">Courses</h6>

                        </li>
                        <li class="list-group-item border-0 bg-transparent">
                            <!-- <span class="border-box"></span> -->
                            <h3 class="text-white">{{getCount('TUTORS')}}+</h3>
                            <img src="assets/img/icons/Trainer.png" width="30px" width="30px" class="img-fluid" alt="">
                            <h6 class="mt-3 text-white">Trainers</h6>

                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-layer-style1"></div>
    <div class="bg-layer-style2"></div>
</section>